import { Link } from 'react-router-dom';

export default function SEOContentSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <article className="w-full px-6 md:px-10 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6 text-center">
          What Makes <strong className="text-primary-600">PandabuySpreadsheet</strong> the #1 Trusted Source
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8">
          {[
            {
              icon: 'ri-star-line',
              title: 'Curated High-Quality Finds Only',
              desc: 'Every item in our pandabuy spreadsheet is hand-picked and verified for quality, ensuring you only see the best pandabuyspreadsheet recommendations the community trusts.',
            },
            {
              icon: 'ri-time-line',
              title: 'Updated Daily & Weekly',
              desc: 'The pandabuy spreadsheet landscape changes fast. Our lists are refreshed regularly so your pandabuyspreadsheet data stays accurate and up to date.',
            },
            {
              icon: 'ri-layout-grid-line',
              title: 'Organized by Category & Price',
              desc: 'Navigate effortlessly through 14 organized categories. Whether you need a pandabuy sneakers spreadsheet or a pandabuy clothing spreadsheet, it is all here.',
            },
            {
              icon: 'ri-user-smile-line',
              title: 'Beginner-Friendly Navigation',
              desc: 'New to pandabuy spreadsheet tools? Our intuitive layout and clear pandabuyspreadsheet guides make it simple for anyone to get started immediately.',
            },
          ].map((item) => (
            <div key={item.title} className="flex gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-accent-100 rounded-lg">
                <i className={`${item.icon} text-lg text-accent-700`}></i>
              </div>
              <div>
                <h3 className="text-base font-semibold font-label text-foreground-950 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="prose prose-sm max-w-none text-foreground-700 bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <h3 className="text-xl font-heading text-foreground-950 mb-4">
            Why the PandabuySpreadsheet Community Keeps Growing
          </h3>
          <p className="mb-4 leading-relaxed">
            The <strong>pandabuy spreadsheet</strong> ecosystem has transformed how people discover and share fashion finds online. A well-maintained <strong>pandabuyspreadsheet</strong> acts as a centralized catalog where enthusiasts compile their favorite items, complete with direct links, quality ratings, and price comparisons. Unlike browsing individual stores or social media feeds, a curated <strong>best pandabuy spreadsheet</strong> saves hours of searching by organizing everything in one accessible location.
          </p>
          <p className="mb-4 leading-relaxed">
            Our <strong>pandabuy clothing spreadsheet</strong> and <strong>pandabuy sneakers spreadsheet</strong> categories are particularly popular because they focus on what the community actually wants — verified quality, reasonable pricing, and honest reviews. Every <strong>pandabuyspreadsheet</strong> list we feature goes through a community verification process, ensuring the items you see are genuinely worth your time and attention.
          </p>
          <p className="leading-relaxed">
            Whether you are searching for a <strong>pandabuy budget spreadsheet</strong> to find affordable essentials or exploring premium <strong>pandabuy finds list</strong> recommendations, our hub connects you directly to the most up-to-date and reliable pandabuy spreadsheet resources available. Bookmark this page and check back often — new pandabuyspreadsheet content is added every week.
          </p>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/article/pandabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold font-label bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-article-line"></i>
            Read Full Pandabuy Sheet Guide
          </Link>
        </div>
      </article>
    </section>
  );
}